export enum AuthButtonVariant {
  FILLED = 'filled',
  GHOST = 'ghost',
  FILLED_BLUE = 'filled-blue'
}

export enum AuthButtonColor {
  LIGHT = 'light',
  DARK = 'dark',
  GHOST_DARKER = 'ghost-darker'
}
